/** Animated SVG energy flow from station to device. */
export default function EnergyFlow({ priority = "standard", active = true, height = 100 }) {
  const colorMap = {
    emergency: "#FF3838",
    medical: "#00D2FF",
    public_safety: "#FF8A00",
    premium: "#FACC15",
    standard: "#00E5FF",
    background: "#71717A",
  };
  const color = colorMap[priority] || "#00E5FF";
  const speedClass =
    priority === "emergency" ? "bin-flow-emergency" :
    priority === "background" ? "bin-flow-background" : "";

  return (
    <svg viewBox="0 0 400 100" style={{ width: "100%", height }}>
      {/* Station node */}
      <g transform="translate(40, 50)">
        <rect x="-16" y="-16" width="32" height="32" fill="none" stroke={color} strokeWidth="1.5" />
        <rect x="-8" y="-8" width="16" height="16" fill={color} opacity="0.2" />
        <text x="0" y="36" textAnchor="middle" fill="#A1A1AA" fontSize="9" fontFamily="IBM Plex Mono">STATION</text>
      </g>

      {/* Path */}
      <path
        d="M 60 50 Q 200 20 340 50"
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        className={active ? `bin-flow-path ${speedClass}` : ""}
        opacity={active ? 1 : 0.3}
      />

      {/* Device node */}
      <g transform="translate(360, 50)">
        <circle cx="0" cy="0" r="14" fill="none" stroke={color} strokeWidth="1.5" />
        <circle cx="0" cy="0" r="6" fill={color} opacity={active ? "0.9" : "0.3"} />
        <text x="0" y="36" textAnchor="middle" fill="#A1A1AA" fontSize="9" fontFamily="IBM Plex Mono">DEVICE</text>
      </g>
    </svg>
  );
}
